import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DOCUMENT } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import { Router, NavigationEnd } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FuseConfigService } from '@fuse/services/config.service';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseSplashScreenService } from '@fuse/services/splash-screen.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { navigation } from 'app/navigation/navigation';
import { lang_navigation } from 'app/idiomas/i18n/navigation/navigation.lang';
import { lang_modales } from 'app/idiomas/i18n/modales/modales.lang';

import { AuthService } from 'app/auth/auth.service';
import { ConnectionService } from 'ng-connection-service';
import Swal from 'sweetalert2';
import *  as $ from 'jquery';

@Component({
    selector   : 'app',
    templateUrl: './app.component.html',
    styleUrls  : ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy
{
    fuseConfig: any;
    navigation: any;

    form = this._formBuilder.group({
        colorTheme      : new FormControl(),
        customScrollbars: new FormControl(),
        layout          : this._formBuilder.group({
            style    : new FormControl(),
            width    : new FormControl(),
            navbar   : this._formBuilder.group({
                primaryBackground  : new FormControl(),
                secondaryBackground: new FormControl(),
                folded             : new FormControl(),
                hidden             : new FormControl(),
                position           : new FormControl(),
                variant            : new FormControl()
            }),
            toolbar  : this._formBuilder.group({
                background           : new FormControl(),
                customBackgroundColor: new FormControl(),
                hidden               : new FormControl(),
                position             : new FormControl()
            }),
            footer   : this._formBuilder.group({
                background           : new FormControl(),
                customBackgroundColor: new FormControl(),
                hidden               : new FormControl(),
                position             : new FormControl()
            }),
            sidepanel: this._formBuilder.group({
                hidden  : new FormControl(),
                position: new FormControl()
            })
        })
    });

    status = 'ONLINE'; //initializing as online by default
    isConnected = true;

    // Private
    private _unsubscribeAll: Subject<any>;

    /**
     * Constructor
     *
     * @param {DOCUMENT} document
     * @param {FuseConfigService} _fuseConfigService
     * @param {FuseNavigationService} _fuseNavigationService
     * @param {FuseSidebarService} _fuseSidebarService
     * @param {FuseSplashScreenService} _fuseSplashScreenService
     * @param {FuseTranslationLoaderService} _fuseTranslationLoaderService
     * @param {Platform} _platform
     * @param {TranslateService} _translateService
     */
    constructor(
        @Inject(DOCUMENT) private document: any,
        private _fuseConfigService: FuseConfigService,
        private _fuseNavigationService: FuseNavigationService,
        private _fuseSidebarService: FuseSidebarService,
        private _fuseSplashScreenService: FuseSplashScreenService,
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _translateService: TranslateService,
        private _platform: Platform,
        private authService: AuthService,
        private connectionService:ConnectionService,
        private _formBuilder: FormBuilder,
        private router: Router
    )
    {
        //funcion que le quita el menu con clic derecho a los videos xd
        this.router.events.subscribe((ev) => {
          if (ev instanceof NavigationEnd) {
            /* Your code goes here on every router change */
            //console.log("cambio la pagina alv :o");
            setTimeout(() => {
              let list = document.getElementsByTagName("VIDEO");
              for(let i=0;i<list.length;i++){
                list[i].addEventListener('contextmenu', e => {
                  e.preventDefault();
                });
              }
            }, 2000);
          }
        });

        // Get default navigation
        this.navigation = navigation;
        // Register the navigation to the service
        this._fuseNavigationService.register('main', this.navigation);
        // Set the main navigation as our current navigation
        this._fuseNavigationService.setCurrentNavigation('main');
        // Add languages
        this._translateService.addLangs(['en','es','tr','zh1','zh2']);

        let idiomaNavegador = navigator.language.split("-");

        let idiomaCGO: string;
        switch(idiomaNavegador[0]){
          case 'en': idiomaCGO = 'en'; break;
          case 'es': idiomaCGO = 'es'; break;
          case 'tr': idiomaCGO = 'tr'; break;
          case 'zh':
            switch (idiomaNavegador[1]) {
              case 'TW': idiomaCGO = 'zh1'; break;
              case 'CN': idiomaCGO = 'zh2'; break;
              default: idiomaCGO = 'zh1';
            }
          break;
          default: idiomaCGO = 'en';
        }

        // Set the default language
        this._translateService.setDefaultLang('en');

        // Set the navigation translations
        lang_navigation.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
        });
        lang_modales.forEach((locale) => {
            this._fuseTranslationLoaderService.loadTranslations(locale);
        });

        // Use a language
        this._translateService.use(idiomaCGO);

        //comprueba estatus de conexion a intenet alv
        this.connectionService.monitor().subscribe(isConnected => {
          this.isConnected = isConnected;
          if(this.isConnected){
            // this.status = "ONLINE";
            this.modalErrorConexion('CON','success',true);
          } else {
            // this.status = "OFFLINE"
            this.modalErrorConexion('SIN','error',false);
          }
          // alert(this.status);
        });

        /**
         * ----------------------------------------------------------------------------------------------------
         * ngxTranslate Fix Start
         * ----------------------------------------------------------------------------------------------------
         */

        /**
         * If you are using a language other than the default one, i.e. Turkish in this case,
         * you may encounter an issue where some of the components are not actually being
         * translated when your app first initialized.
         *
         * This is related to ngxTranslate module and below there is a temporary fix while we
         * are moving the multi language implementation over to the Angular's core language
         * service.
         **/

        // Set the default language to 'en' and then back to 'tr'.
        // '.use' cannot be used here as ngxTranslate won't switch to a language that's already
        // been selected and there is no way to force it, so we overcome the issue by switching
        // the default language back and forth.

         // setTimeout(() => {
         //    this._translateService.setDefaultLang('es');
         //    this._translateService.setDefaultLang('en');
         // },3000);


        /**
         * ----------------------------------------------------------------------------------------------------
         * ngxTranslate Fix End
         * ----------------------------------------------------------------------------------------------------
         */

        // Add is-mobile class to the body if the platform is mobile
        if ( this._platform.ANDROID || this._platform.IOS )
        {
            this.document.body.classList.add('is-mobile');
        }

        // Set the private defaults
        this._unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {
      //se ejecuta la comprobacion de si el usuario esta autenticado cada que entra el app component
      this.authService.autoAuthUser();
        // Subscribe to config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {

                this.fuseConfig = config;

                // Boxed
                if ( this.fuseConfig.layout.width === 'boxed' )
                {
                    this.document.body.classList.add('boxed');
                }
                else
                {
                    this.document.body.classList.remove('boxed');
                }

                // Color theme - Use normal for loop for IE11 compatibility
                for ( let i = 0; i < this.document.body.classList.length; i++ )
                {
                    const className = this.document.body.classList[i];

                    if ( className.startsWith('theme-') )
                    {
                        this.document.body.classList.remove(className);
                    }
                }

                this.document.body.classList.add(this.fuseConfig.colorTheme);

                //parche tema
                this.form.setValue(config, {emitEvent: false});
            });

            this.form.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe((config) => {
                // Update the config
                //console.log("cambiara tema");
                this._fuseConfigService.config = config;
            });
            this.cambiaTema();

              setInterval(function() {
                  $('.spinnerCGO').css('background-image', `url(${localStorage.getItem('urlGifBroker')})`);
              }, 20);

    }

    cambiaTema(){
      let isAuth = this.authService.getIsAuth();
      //console.log("Auth "+isAuth);
      //console.log("broker "+localStorage.getItem('tipoBroker'));
      if(!localStorage.getItem('tipoBroker') && isAuth){
        this.form.controls['colorTheme'].setValue('temaFocusArea2');
      }
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void
    {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    modalErrorConexion(opcion:string, tipo:string, botOk:boolean){
      let tipoMsg: any = tipo;
      let texto = 'MODALES.MENSAJES.CONEX.'+opcion;
      let botonModal = 'MODALES.ACCIONES.aceptar';
      this._translateService.get(texto).subscribe((res: string) => { texto = res; });
      this._translateService.get(botonModal).subscribe((res: string) => { botonModal = res; });
      Swal.fire({
        icon: tipoMsg,
        title: texto,

        confirmButtonText: botonModal,
        showConfirmButton: botOk,
        allowOutsideClick: false
      })
    }
}
